import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'

import './navigation.css'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <nav className="navigation-wrapper">
        <div className="navigation-container">
            <div aria-label="Bajwa Co Home" className="navigation-brand">
              <span className="navigation-brand-name">Bajwa Co</span>
              <span className="navigation-brand-tag">Creator Management</span>
            </div>
          <div className="navigation-desktop-menu">
            <ul className="navigation-links">
              <li className="navigation-item">
              </li>
              <li className="navigation-item">
                <a href="#how">
                  <div className="navigation-thq-navigation-link-elm2 navigation-link">
                    <span>How It Works</span>
                  </div>
                </a>
              </li>
              <li className="navigation-item">
                <a href="#why">
                  <div className="navigation-thq-navigation-link-elm3 navigation-link">
                    <span>Why Me</span>
                  </div>
                </a>
              </li>
            </ul>
            <a href="#contact">
              <div className="btn btn-md btn-primary">
                <span>Get In Touch</span>
                <svg
                  fill="none"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  height="20"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14m-7-7l7 7l-7 7"></path>
                </svg>
              </div>
            </a>
          </div>
          <button
            id="navToggle"
            aria-label="Toggle navigation"
            aria-expanded="false"
            className="navigation-toggle"
          >
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon-menu"
            >
              <path d="M4 12h16M4 6h16M4 18h16"></path>
            </svg>
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon-close"
            >
              <path d="M18 6L6 18M6 6l12 12"></path>
            </svg>
          </button>
        </div>
      </nav>
      <div id="mobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-mobile-header">
          <Link to="/">
            <div aria-label="Bajwa Co Home" className="navigation-brand">
              <span className="navigation-brand-name">Bajwa Co</span>
            </div>
          </Link>
          <button
            id="closeOverlay"
            aria-label="Close navigation"
            className="navigation-toggle-close"
          >
            <svg
              fill="none"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6L6 18M6 6l12 12"></path>
            </svg>
          </button>
        </div>
        <div className="navigation-mobile-content">
          <ul className="navigation-mobile-links">
            <li className="navigation-mobile-item">
              <a href="#how">
                <div className="navigation-mobile-link">
                  <span>How It Works</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="#why">
                <div className="navigation-mobile-link">
                  <span>Why Me?</span>
                </div>
              </a>
            </li>
            <li className="navigation-mobile-item">
              <a href="#contact">
                <div className="navigation-mobile-link">
                  <span>Contact</span>
                </div>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<script defer data-name="navigation-logic">
(function(){
  const navToggle = document.getElementById('navToggle');
  const closeOverlay = document.getElementById('closeOverlay');
  const mobileOverlay = document.getElementById('mobileOverlay');
  const navLinks = document.querySelectorAll('.navigation-mobile-link');
  const body = document.body;

  const openMenu = () => {
    mobileOverlay.style.display = 'flex';
    body.style.overflow = 'hidden';
    navToggle.setAttribute('aria-expanded', 'true');
  };

  const closeMenu = () => {
    mobileOverlay.style.display = 'none';
    body.style.overflow = '';
    navToggle.setAttribute('aria-expanded', 'false');
  };

  navToggle.addEventListener('click', openMenu);
  closeOverlay.addEventListener('click', closeMenu);

  navLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  let lastScroll = 0;
  const navWrapper = document.querySelector('.navigation-wrapper');

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    if (currentScroll <= 0) {
      navWrapper.style.transform = 'translateY(0)';
      return;
    }

    if (currentScroll > lastScroll && currentScroll > 100) {
      navWrapper.style.transform = 'translateY(-100%)';
    } else {
      navWrapper.style.transform = 'translateY(0)';
    }
    
    lastScroll = currentScroll;
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Navigation
